import {Injectable} from '@angular/core'
import {Observable} from 'rxjs'
import {map} from 'rxjs/operators'
import {SearchFilter} from '@app/core/services/search/search-filter.interface'
import {
  GenericListService,
  LoadRequest,
  LoadResult,
} from '../generic-list.service'
import {NotificationService} from '@app/core/services/notification.service'
import {LoggerService} from '@app/core/services/logger.service'
import {ContextService} from '@app/core/services/context.service'
import {AlertService} from '@app/core/services/alert/alert.service'
import {Alert} from '@app/core/services/alert/alert.interface'
import {GetRegistrationsRequest} from '@app/core/services/contract/contract.service'

@Injectable()
export class AlertListService extends GenericListService<Alert> {
  filter: SearchFilter
  constructor(
    private alertSvc: AlertService,
    protected notify: NotificationService,
    protected contextSvc: ContextService,
    protected logger: LoggerService,
  ) {
    super(notify, logger)
  }

  retrieve(request: LoadRequest): Observable<LoadResult<Alert>> {
    const svcRequest: GetRegistrationsRequest = {
      domain: request.domain,
      offset: request.offset,
      results: request.count,
    }

    if (this.filter) {
      svcRequest.search = this.filter.query
      svcRequest.sort = this.filter.sort
      svcRequest.asc = this.filter.asc
    }
    return this.alertSvc.getAlerts(svcRequest).pipe(
      map((res: Alert[]) => {
        return {
          total: res.length,
          items: res,
        }
      }),
    )
  }
}
